// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b55a03d","453":"381a18ff","732":"db0048fb","977":"07ba0948"}[chunkId] + ".chunk.js";
};